module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.appPage.meta.noFooter),
      expression: "!appPage.meta.noFooter"
    }],
    staticClass: "block--accent footer"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "small mt0 mb0"
  }, [_vm._v("Built in Vue with Vue Init by "), _c('module-link', {
    attrs: {
      "link": "https://fueled.com"
    }
  }, [_vm._v("Fueled")]), _vm._v(", see the source on "), _c('module-link', {
    attrs: {
      "link": "https://github.com/robsterlini/robsterlini-frontend"
    }
  }, [_vm._v("Github")]), _vm._v(".")], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4120d3dc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Footer.vue
// module id = 34
// module chunks = 1